import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EmployeeWorkRelatedList from "./EmployeeWorkRelatedList";
import { DataContext } from "../../helper/HelperOne";
import NavBar from "../nav_bar/Navbar";

function EmployeeWorkRelated() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<EmployeeWorkRelatedList />}
                menuId={17}
            />
        </DataContext.Provider>
    );
}

export default EmployeeWorkRelated;
